 
if (!customElements.get('collection-card-slider')) {
  class CollectionCardSlider extends HTMLElement {
    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    initSwiper() {
      const swiperEl = this.querySelector('.collection-card-slider__swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      const prevButton = this.querySelector('.collection-card-slider__button--prev');
      const nextButton = this.querySelector('.collection-card-slider__button--next');
      const current = this.querySelector('.collection-card-slider__current');

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
         
        touchReleaseOnEdges: true,
        on: {
          init: (swiper) => this.updateCount(swiper, current),
          slideChange: (swiper) => this.updateCount(swiper, current),
        },
      });

      
      [
        [prevButton, () => this.swiper.slidePrev()],
        [nextButton, () => this.swiper.slideNext()],
      ].forEach(([button, action]) => {
        button?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          action();
        });
      });
    }

    updateCount(swiper, current) {
      if (current) current.textContent = String(swiper.realIndex + 1);
    }
  }

  customElements.define('collection-card-slider', CollectionCardSlider);
}
